/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import useCloseModalLineMenu from '../../../../../hooks/useCloseModalLineMenu';
import DailyReport from '../DailyReport/DailyReport';
import WorkReportLineMenu from '../../../WorkReportActionButtons/WorkReportLineMenu/WorkReportLineMenu';
import DeleteLineModal from '../../../DeleteLineModal';
import ModalLineMenu from '../../../ModalLineMenu/ModalLIneMenu';
import { workReportLineStatus } from '../../../../../utils/dataStatus';
import { PositionLinePermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';
import { LineToAPpprove } from '../../../../../utils/globalPropTypes';
import { notificador, proveedorNotificador } from '../../../../../security/constantsRols';
import { checkRol } from '../../../../../security';

const WeeklyLinesContainer = (props) => {
  const {
    changeInLine,
    indexLine,
    indexPosition,
    line,
    newFetch,
    positionLinesPermissions,
    selectedDate,
    setChangeInLine,
    setLines,
    setNewFetch,
    showSeparator,
    startDate,
    typeOfUbication,
    disabledEditStateCancelOrFinish,
    forceWindow,
    isOyM
  } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [dailiesReport, setDailiesReport] = useState([]);
  const [lineInfo, setLineInfo] = useState({});
  const isProviderOrNotifier = checkRol(proveedorNotificador) || checkRol(notificador);
  const isLineBlockedBySap = line?.bloqueadoEnSap && isProviderOrNotifier;

  const { wrapperRef, showModalMenu, setShowModalMenu } = useCloseModalLineMenu();

  useEffect(() => {
    const adapter = line?.partesDiarios?.map((dailyWorkReport) => {
      const numeroDia = new Date(dailyWorkReport.fecha).getDate();

      return {
        ...dailyWorkReport,
        disabled: !(
          dailyWorkReport.estadoEnum === workReportLineStatus.pendiente ||
          dailyWorkReport.estadoEnum === workReportLineStatus.devolver
        ),
        numeroDia,
        descripcionLineaSap: line.descripcionLineaSap,
        numeroLinea: line.numeroLinea,
        numeroPosicion: line.numeroPosicion,
        descripcionPosicionSap: line.descripcionPosicionSap,
        factorConversion: line.factorConversion
        // notificationDates: ['2022-11-07T00:00:00', '2022-11-09T00:00:00']
      };
    });

    setDailiesReport(adapter);
  }, [line]);

  useEffect(() => {
    setLineInfo({
      descripcionLineaSap: line.descripcionLineaSap,
      numeroLinea: line.numeroLinea,
      numeroPosicion: line.numeroPosicion,
      descripcionPosicionSap: line.descripcionPosicionSap,
      idPartetrabajo: line.idPartetrabajo,
      idParteLinea: line.idParteLinea,
      factorConversion: line.factorConversion
    });
  }, [line]);

  return (
    <>
      <div className="weekly_lines_wrapper">
        <div className="d-flex">
          <Col sm={6}>
            <div className="label_row_position">Línea</div>
            <div className="line_row_name">
              <span className={`${isLineBlockedBySap ? 'text-danger' : ''}`}>
                {line?.lineName?.toUpperCase()}
              </span>
            </div>
          </Col>
          <Col ref={wrapperRef} sm={6}>
            <div className="work_report_weekly_menu">
              <div>
                <div className="label_row_position">UM</div>
                <div className="line_row_name">
                  <span className={`${isLineBlockedBySap ? 'text-danger' : ''}`}>
                    {line?.unidadMedida?.toUpperCase()}
                  </span>
                </div>
              </div>
              <WorkReportLineMenu
                setShowModalMenu={setShowModalMenu}
                showModalMenu={showModalMenu}
              />
              <ModalLineMenu
                disabledByView
                disabledDeleteAction={!positionLinesPermissions.deleteLine}
                disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                disabledRectifyLine={!positionLinesPermissions.rectifyLine}
                line={lineInfo}
                setShowDeleteModal={setShowDeleteModal}
                setShowModalMenu={setShowModalMenu}
                setWorkReportLines={() => {
                  /* empty */
                }}
                showModalMenu={showModalMenu}
              />
            </div>
          </Col>
        </div>

        <div className="daily_report_wrapper">
          {dailiesReport?.map((dailyReport, index) => (
            <DailyReport
              changeInLine={changeInLine}
              dailyReport={dailyReport}
              disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
              enableNotification={dailyReport.habilitaNotificacion}
              forceWindow={forceWindow}
              indexLine={indexLine}
              indexPosition={indexPosition}
              indexWorkReport={index}
              isOyM={isOyM}
              key={dailyReport.id}
              line={line}
              newFetch={newFetch}
              partesDiarios={line.partesDiarios}
              positionLinesPermissions={positionLinesPermissions}
              selectedDate={selectedDate}
              setChangeInLine={setChangeInLine}
              setLines={setLines}
              setNewFetch={setNewFetch}
              startDate={startDate}
              typeOfUbication={typeOfUbication}
            />
          ))}
        </div>
        {showSeparator && <hr />}
      </div>
      <DeleteLineModal
        changeInLines={changeInLine}
        line={{
          ...lineInfo,
          idParteDiario: dailiesReport[0]?.id
        }}
        setChangeInLines={setChangeInLine}
        setNewFetch={setNewFetch}
        setShowDeleteModal={setShowDeleteModal}
        showDeleteModal={showDeleteModal}
      />
    </>
  );
};

WeeklyLinesContainer.propTypes = {
  line: PropTypes.shape({
    descripcionLineaSap: PropTypes.string,
    descripcionLineaYClic: PropTypes.string,
    descripcionPosicionSap: PropTypes.string,
    idPartetrabajo: PropTypes.number,
    lineName: PropTypes.string,
    numeroLinea: PropTypes.number,
    numeroPosicion: PropTypes.number,
    idParteLinea: PropTypes.number,
    factorConversion: PropTypes.number,
    partesDiarios: PropTypes.oneOfType([LineToAPpprove, PropTypes.arrayOf(LineToAPpprove)]),
    unidadMedida: PropTypes.string,
    bloqueadoEnSap: PropTypes.bool
  }).isRequired,
  setChangeInLine: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  changeInLine: PropTypes.bool.isRequired,
  setLines: PropTypes.func.isRequired,
  newFetch: PropTypes.bool.isRequired,
  setNewFetch: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  indexPosition: PropTypes.number.isRequired,
  indexLine: PropTypes.number.isRequired,
  showSeparator: PropTypes.bool.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  forceWindow: PropTypes.bool,
  isOyM: PropTypes.bool
};
WeeklyLinesContainer.defaultProps = {
  forceWindow: null,
  isOyM: false
};
export default WeeklyLinesContainer;
